export const CONTENT = {
  NOTIFICATION: {
    event: "gaGenericEvent",
    event_name: "cta_notification",
    buttonName: "notification_type",
    //Will be empty
    screen_name: "Tap to start",
    section_name: "Tap to start",
    event_type: "button_click",
    error_message: "",
    user_status: "",
    timestamp: Date.now(),
  },
  MENU: {
    event: "gaGenericEvent",
    buttonName: "menu",
    screen_name: "menubar",
    event_type: "button_click",
    error_message: "",
    user_status: "",
    timestamp: Date.now(),
  },
  TAP_TO_START: {
    START: {
      event: "gaGenericEvent",
      event_name: "cta_start",
      buttonName: "start",
      screen_name: "Start",
      section_name: "Start",
      event_type: "button_click",
      error_message: "",
      user_status: "",
      timestamp: Date.now(),
    },
    SKIP_FOR_NOW: {
      event: "gaGenericEvent",
      event_name: "cta_skip",
      buttonName: "skip",
      screen_name: "Skip",
      section_name: "Skip",
      event_type: "button_click",
      error_message: "",
      user_status: "",
      timestamp: Date.now(),
    },
  },
  ARTICLE_CARD: {
    event: "gaGenericEvent",
    event_name: "cta_article_readmore",
    screen_name: "",
    section_name: "read more",
    event_type: "button_click",
    error_message: "",
    user_status: "",
    timestamp: Date.now(),
  },
  PROFILE: {
    COUNTRY_SELECTION: {
      event: "gaGenericEvent",
      event_name: "cta_country_selection",
      screen_name: "",
      section_name: "Country selection",
      event_type: "button_click",
      buttonName: "Country selection",
      error_message: "",
      user_status: "",
      timestamp: Date.now(),
    },
    VIEW_RESULT: {
      event: "gaGenericEvent",
      event_name: "cta_view_result",
      buttonName: "view_result",
      screen_name: "View_result",
      section_name: "view_result",
      event_type: "button_click",
      error_message: "",
      user_status: "",
      timestamp: Date.now(),
    },
    TRY_CANESMENO_QUIDE: {
      event: "gaGenericEvent",
      event_name: "cta_try_canesmeno_guide",
      buttonName: "try_canesmeno_guide",
      screen_name: "Try_canesmeno_guide",
      section_name: "Try_canesmeno_guide",
      event_type: "button_click",
      error_message: "",
      user_status: "",
      timestamp: Date.now(),
    },
    PERSONAL_DATA: {
      event: "gaGenericEvent",
      event_name: "cta_personaldata",
      buttonName: "save_personalData",
      screen_name: "personal_data",
      section_name: "save-personalData",
      event_type: "button_click",
      error_message: "",
      user_status: "",
      timestamp: Date.now(),
    },
    PERSONAL_DATA_PROFILE: {
      event: "gaGenericEvent",
      event_name: "cta_personaldata_profile",
      buttonName: "profile_personaldata",
      section_name: "profile",
      event_type: "button_click",
      error_message: "",
      user_status: "",
      screen_name: "personal_data_profile",
      timestamp: Date.now(),
    },
    NOTIFICATION: {
      event: "gaGenericEvent",
      event_name: "cta_notification",
      buttonName: "save_notifications",
      section_name: "notifications",
      screen_name: "notification",
      event_type: "button_click",
      error_message: "",
      user_status: "",
      timestamp: Date.now(),
    },
    NOTIFICATION_TOGGLE: {
      event: "gaGenericEvent",
      section_name: "notifications",
      screen_name: "notification",
      event_type: "button_click",
      error_message: "",
      user_status: "",
      timestamp: Date.now(),
    },
    NOTIFICATION_PROFILE: {
      event: "gaGenericEvent",
      event_name: "cta_notification_profile",
      buttonName: "profile_notifications",
      section_name: "profile",
      event_type: "button_click",
      screen_name: "notification_profile",
      error_message: "",
      user_status: "",
      timestamp: Date.now(),
    },
    COUNTRY_PROFILE: {
      event: "gaGenericEvent",
      event_name: "cta_country_profile",
      buttonName: "profile_country",
      section_name: "profile",
      event_type: "button_click",
      screen_name: "country_profile",
      error_message: "",
      user_status: "",
      timestamp: Date.now(),
    },
  },
  WELCOME: {
    LOGIN: {
      event: "gaGenericEvent",
      event_name: "cta_login",
      buttonName: "login",
      screen_name: "Login",
      section_name: "Login",
      event_type: "button_click",
      error_message: "",
      user_status: "",
      timestamp: Date.now(),
    },
    REGISTER: {
      event: "gaGenericEvent",
      event_name: "cta_register",
      buttonName: "register",
      screen_name: "Register",
      section_name: "Register",
      event_type: "button_click",
      error_message: "",
      user_status: "",
      timestamp: Date.now(),
    },
  },
  WELCOME_PAGE: {
    GET_STARTED: {
      event: "gaGenericEvent",
      event_name: "cta_get_started",
      buttonName: "get_started",
      section_name: "get_started",
      event_type: "button_click",
      screen_name: "welcome",
      error_message: "",
      user_status: "",
      timestamp: Date.now(),
    },
    LOGIN: {
      event: "gaGenericEvent",
      event_name: "cta_login",
      buttonName: "login",
      section_name: "login",
      event_type: "button_click",
      screen_name: "welcome",
      error_message: "",
      user_status: "",
      timestamp: Date.now(),
    },
  },
  INTRO: {
    NEXT: {
      event: "gaGenericEvent",
      event_name: "cta_next",
      buttonName: "next",
      section_name: "next",
      event_type: "button_click",
      screen_name: "intro",
      error_message: "",
      user_status: "",
      timestamp: Date.now(),
    },
  },
  HOME: {
    DAILYPULSECHECK: {
      event: "gaGenericEvent",
      event_name: "cta_pulsecheck",
      screen_name: "Pulsecheck",
      section_name: "Pulsecheck",
      event_type: "button_click",
      error_message: "",
      user_status: "",
      timestamp: Date.now(),
    },
    CHANGEPULSE: {
      event: "gaGenericEvent",
      event_name: "cta_changepulse",
      buttonName: "changepulse",
      screen_name: "Changepulse",
      section_name: "Changepulse",
      event_type: "button_click",
      error_message: "",
      user_status: "",
      timestamp: Date.now(),
    },
    TRACKTODAY: {
      event: "gaGenericEvent",
      event_name: "cta_tracktoday",
      buttonName: "tracktoday",
      screen_name: "Tracktoday",
      section_name: "Tracktoday",
      event_type: "button_click",
      error_message: "",
      user_status: "",
      timestamp: Date.now(),
    },
    INSIGHTSEXLPORE: {
      event: "gaGenericEvent",
      event_name: "cta_insightsexplore",
      buttonName: "insightsexplore",
      screen_name: "Insightsexplore",
      section_name: "Insightsexplore",
      event_type: "button_click",
      error_message: "",
      user_status: "",
      timestamp: Date.now(),
    },
    INSIGHTSTRACK: {
      event: "gaGenericEvent",
      event_name: "cta_insightstrack",
      buttonName: "insightstrack",
      screen_name: "Insightstrack",
      section_name: "Insightstrack",
      event_type: "button_click",
      error_message: "",
      user_status: "",
      timestamp: Date.now(),
    },
    ABOUTMENOPAUSECARD: {
      event: "gaGenericEvent",
      event_name: "cta_aboutmenopause",
      buttonName: "aboutmenopause",
      screen_name: "Aboutmenopause",
      section_name: "Aboutmenopause",
      event_type: "button_click",
      error_message: "",
      user_status: "",
      timestamp: Date.now(),
    },
    YOURCOACHCARD: {
      event: "gaGenericEvent",
      event_name: "cta_yourcoach",
      buttonName: "yourcoach",
      screen_name: "Yourcoach",
      section_name: "Yourcoach",
      event_type: "button_click",
      error_message: "",
      user_status: "",
      timestamp: Date.now(),
    },
    CAROUSELEXLPORE: {
      event: "gaGenericEvent",
      event_name: "cta_carouselexplore",
      buttonName: "carouselexplore",
      screen_name: "Carouselexplore",
      section_name: "Carouselexplore",
      event_type: "button_click",
      error_message: "",
      user_status: "",
      timestamp: Date.now(),
    },
    EXLPOREPRODUCTS: {
      event: "gaGenericEvent",
      event_name: "cta_exploreproducts",
      buttonName: "exploreproducts",
      screen_name: "Exploreproducts",
      section_name: "Exploreproducts",
      event_type: "button_click",
      error_message: "",
      user_status: "",
      timestamp: Date.now(),
    },
  },
  EXPLOREALL: {
    ABOUTMENOPAUSECARD: {
      event: "gaGenericEvent",
      event_name: "cta_aboutmenopause",
      buttonName: "aboutmenopause",
      screen_name: "Aboutmenopause",
      section_name: "Aboutmenopause",
      event_type: "button_click",
      error_message: "",
      user_status: "",
      timestamp: Date.now(),
    },
    YOURCOACHCARD: {
      event: "gaGenericEvent",
      event_name: "cta_yourcoach",
      buttonName: "yourcoach",
      screen_name: "Yourcoach",
      section_name: "Yourcoach",
      event_type: "button_click",
      error_message: "",
      user_status: "",
      timestamp: Date.now(),
    },
    OURPRODUCTSCARD: {
      event: "gaGenericEvent",
      event_name: "cta_ourproducts",
      buttonName: "ourproducts",
      screen_name: "Ourproducts",
      section_name: "Ourproducts",
      event_type: "button_click",
      error_message: "",
      user_status: "",
      timestamp: Date.now(),
    },
    CAROUSELABOUTMENOPAUSEEXLPORE: {
      event: "gaGenericEvent",
      event_name: "cta_carouselaboutmenopauseexplore",
      buttonName: "carouselaboutmenopauseexplore",
      screen_name: "Carouselaboutmenopauseexplore",
      section_name: "Carouselaboutmenopauseexplore",
      event_type: "button_click",
      error_message: "",
      user_status: "",
      timestamp: Date.now(),
    },
    YOURCOACHEXLPORE: {
      event: "gaGenericEvent",
      event_name: "cta_yourcoachexplore",
      buttonName: "yourcoachexplore",
      screen_name: "Yourcoachexplore",
      section_name: "Yourcoachexplore",
      event_type: "button_click",
      error_message: "",
      user_status: "",
      timestamp: Date.now(),
    },
  },
  LEARN: {
    CAROUSELMENOPAUSE101EXLPORE: {
      event: "gaGenericEvent",
      event_name: "cta_menopauseexplore",
      buttonName: "menopauseexplore",
      screen_name: "Menopauseexplore",
      section_name: "Menopauseexplore",
      event_type: "button_click",
      error_message: "",
      user_status: "",
      timestamp: Date.now(),
    },
    CAROUSELSYMPTOMSEXLPORE: {
      event: "gaGenericEvent",
      event_name: "cta_symptoms",
      buttonName: "symptoms",
      screen_name: "Symptoms",
      section_name: "Symptoms",
      event_type: "button_click",
      error_message: "",
      user_status: "",
      timestamp: Date.now(),
    },
    CAROUSELTREATMENTSEXLPORE: {
      event: "gaGenericEvent",
      event_name: "cta_treatments",
      buttonName: "treatments",
      screen_name: "Treatments",
      section_name: "Treatments",
      event_type: "button_click",
      error_message: "",
      user_status: "",
      timestamp: Date.now(),
    },
    CAROUSELEQUIPYOURSELFEXLPORE: {
      event: "gaGenericEvent",
      event_name: "cta_equipyourself",
      buttonName: "equipyourself",
      screen_name: "Equipyourself",
      section_name: "Equipyourself",
      event_type: "button_click",
      error_message: "",
      user_status: "",
      timestamp: Date.now(),
    },
    TABS: {
      event: "gaGenericEvent",
      screen_name: "explore",
      event_type: "button_click",
      error_message: "",
      user_status: "",
      timestamp: Date.now(),
    },
  },
  MQ6: {
    INTRO: {
      START: {
        event: "gaGenericEvent",
        event_name: "cta_quiz_start",
        buttonName: "quiz_start",
        section_name: "Quiz",
        screen_name: "Quiz",
        event_type: "button_click",
        error_message: "",
        user_status: "",
      },
      ABOUT: {
        event: "gaGenericEvent",
        event_name: "cta_quiz_start_part_2",
        buttonName: "quiz_part_2",
        section_name: "Quiz",
        screen_name: "Quiz",
        event_type: "button_click",
        error_message: "",
        user_status: "",
      },
    },
    QUIZ_COMPLETE: {
      event: "gaGenericEvent",
      event_name: "cta_quiz_complete",
      buttonName: "quiz_complete",
      section_name: "Quiz",
      screen_name: "Quiz_complete",
      event_type: "button_click",
      error_message: "",
      user_status: "",
    },
    QUESTIONS: {
      event: "gaGenericEvent",
      event_name: "cta_assessment",
      section_name: "Quiz",
      screen_name: "Quiz",
      event_type: "button_click",
      buttonName: "Next_Question",
      error_message: "",
      user_status: "",
    },
  },
  RESTRICTED_PAGES: {
    event: "gaGenericEvent",
    buttonName: "",
    section_name: "Daily Tracker",
    screen_name: "Daily Tracker",
    event_type: "button_click",
    error_message: "",
    user_status: "",
  },
  DAILY_TRACKER: {
    TRACK_CARD: {
      event: "gaGenericEvent",
      event_name: "cta_track_card",
      buttonName: "",
      section_name: "Daily Tracker",
      screen_name: "Daily Tracker",
      event_type: "button_click",
      error_message: "",
      user_status: "",
    },
  },
  LOG_PERIOD: {
    LOG_BUTTON: {
      event: "gaGenericEvent",
      event_name: "cta_log_period",
      buttonName: "log_period",
      screen_name: "symptom_tracker",
      section_name: "Log Period",
      event_type: "button_click",
      error_message: "",
      user_status: "",
    },
    REMOVE_LOG_BUTTON: {
      event: "gaGenericEvent",
      event_name: "cta_remove_log_period",
      buttonName: "remove_log_period",
      screen_name: "symptom_tracker",
      section_name: "Remove Log Period",
      event_type: "button_click",
      error_message: "",
      user_status: "",
    },
    CALENDAR_DATE: {
      event: "gaGenericEvent",
      event_name: "cta_calendar_date",
      buttonName: "calender_date",
      screen_name: "symptom_tracker",
      section_name: "Calender",
      event_type: "button_click",
      error_message: "",
      user_status: "",
    },
    CALENDAR_ICON: {
      event: "gaGenericEvent",
      event_name: "cta_calendar_icon",
      buttonName: "calendar_icon",
      screen_name: "symptom_tracker",
      section_name: "symptom tracker",
      event_type: "button_click",
      error_message: "",
      user_status: "",
    },
    TRACK_CALENDAR: {
      event: "gaGenericEvent",
      event_name: "cta_track_calendar",
      section_name: "Track Calendar",
      screen_name: "Track Calendar",
      event_type: "screen_view",
      error_message: "",
    },
  },
  INSIGHTS: {
    TAB: {
      event: "gaGenericEvent",
      event_name: "cta_insights_tab",
      buttonName: "insights_tab",
      section_name: "Insights Page",
      screen_name: "Insights Page",
      event_type: "button_click",
      error_message: "",
      user_status: "",
    },
  },
  PRODUCTS: {
    BUY_NOW: {
      event: "gaGenericEvent",
      event_name: "cta_buy_now",
      buttonName: "buy_now",
      section_name: "Products Page",
      screen_name: "Products Page",
      event_type: "button_click",
      error_message: "",
      view_product_list: "",
      //product_name: "",
    },
    LEARN_MORE: {
      event: "gaGenericEvent",
      event_name: "cta_learn_more",
      buttonName: "learn_more",
      section_name: "Products Page",
      screen_name: "Products Page",
      event_type: "button_click",
      error_message: "",
      view_product_list: "",
      //product_name: "",
    },
    CARD: {
      event: "gaGenericEvent",
      event_name: "cta_card",
      buttonName: "product_card",
      section_name: "Products Page",
      screen_name: "Products Page",
      event_type: "button_click",
      error_message: "",
      //view_product_list: "",
      //product_name: "",
    },
  },
  PRODUCT_DETAILS_PAGE: {
    BUY_NOW_PDP: {
      event: "gaGenericEvent",
      event_name: "cta_buy_now_pdp",
      buttonName: "buy_now_pdp",
      section_name: "Product Details Page",
      screen_name: "Product Details Page",
      event_type: "button_click",
      error_message: "",
      view_product_list: "",
      //product_name: "",
    },
  },
  RESULTS: {
    EXPLORE: {
      event: "gaGenericEvent",
      event_name: "cta_explore",
      buttonName: "explore",
      screen_name: "Explore",
      section_name: "Explore",
      event_type: "button_click",
      error_message: "",
      user_status: "",
      timestamp: Date.now(),
    },
    DOWNLOAD: {
      event: "gaGenericEvent",
      event_name: "cta_download",
      buttonName: "download",
      screen_name: "Download",
      section_name: "Download",
      event_type: "button_click",
      error_message: "",
      user_status: "",
      timestamp: Date.now(),
    },
  },
  CAROUSEL: {
    event: "gaGenericEvent",
    event_name: "cta_carousel",
    screen_name: "",
    section_name: "carousel",
    event_type: "button_click",
    error_message: "",
    timestamp: Date.now(),
  },
  REGISTRATION_STEP_ONE: {
    NEXT: {
      event: "gaGenericEvent",
      event_name: "cta_next",
      buttonName: "next",
      screen_name: "Next",
      section_name: "Next",
      event_type: "button_click",
      error_message: "",
      user_status: "",
      timestamp: Date.now(),
    },
  },
  REGISTRATION_STEP_TWO: {
    ADD_PROFILE_IMAGE: {
      event: "gaGenericEvent",
      event_name: "cta_add",
      buttonName: "add",
      screen_name: "Add",
      section_name: "Add",
      event_type: "button_click",
      error_message: "",
      user_status: "",
      timestamp: Date.now(),
    },
    NEXT: {
      event: "gaGenericEvent",
      event_name: "cta_next",
      buttonName: "next",
      screen_name: "Next",
      section_name: "Next",
      event_type: "button_click",
      error_message: "",
      user_status: "",
      timestamp: Date.now(),
    },
    SKIP_FOR_NOW: {
      event: "gaGenericEvent",
      event_name: "cta_skip",
      buttonName: "skip",
      screen_name: "Skip",
      section_name: "Skip",
      event_type: "button_click",
      error_message: "",
      user_status: "",
      timestamp: Date.now(),
    },
  },
  FAQ: {
    ACCORDIONS: {
      event: "gaGenericEvent",
      event_name: "accordions",
      buttonName: "Accordion",
      screen_name: "faq",
      section_name: "Accordion",
      event_type: "button_click",
      error_message: "",
      user_status: "",
      timestamp: Date.now(),
    },
  },
  GENERAL: {
    PROFILE: {
      event: "gaGenericEvent",
      event_name: "cta_profile",
      buttonName: "profile",
      section_name: "welcome",
      screen_name: "welcome",
      event_type: "button_click",
      error_message: "",
      view_product_list: "",
      //product_name: "",
    },
  },
  MARKETING_POPUP: {
    JOIN_NOW: {
      event: "gaGenericEvent",
      event_name: "cta_join_now",
      buttonName: "join_now",
      section_name: "marketing_popup",
      screen_name: "marketing_popup",
      event_type: "button_click",
      error_message: "",
      view_product_list: "",
      //product_name: "",
    },
    CLOSE_BTN: {
      event: "gaGenericEvent",
      event_name: "cta_close",
      buttonName: "close_popup",
      section_name: "marketing_popup",
      screen_name: "marketing_popup",
      event_type: "button_click",
      error_message: "",
      view_product_list: "",
      //product_name: "",
    },
  },
  GIGYA_SCREENSETS: {
    LOGIN_AND_REGISTER: {
      event: "gaGenericEvent",
      event_name: "cta_continue_with_email",
      buttonName: "continue_with_email",
      section_name: "Login & Register",
      screen_name: "Passwordless login & registration",
      event_type: "button_click",
      page_url: import.meta.env.VITE_PUBLIC_URL,
      error_message: "",
    },
    REG_WITH_PASSWORD: {
      event: "gaGenericEvent",
      event_name: "cta_register_with_password",
      buttonName: "register_with_password",
      section_name: "register with password",
      screen_name: "Pregister with password",
      event_type: "button_click",
      page_url: import.meta.env.VITE_PUBLIC_URL,
      error_message: "",
    },
    REG_WITH_PASSWORD_FORM: {
      event: "gaGenericEvent",
      event_name: "cta_register_with_password_submit",
      buttonName: "register_with_password_submit",
      section_name: "register with password form",
      screen_name: "Pregister with password form",
      event_type: "button_click",
      page_url: import.meta.env.VITE_PUBLIC_URL,
      error_message: "",
    },
    AUTH_METHODS: {
      PASSWORD: {
        event: "gaGenericEvent",
        event_name: "cta_auth_password",
        buttonName: "auth_password",
        section_name: "Authentication Methods",
        screen_name: "Authentication Methods",
        event_type: "button_click",
        page_url: import.meta.env.VITE_PUBLIC_URL,
        error_message: "",
      },
      PASSWORD_SUBMIT_PAGE: {
        event: "gaGenericEvent",
        event_name: "cta_auth_password_submit",
        buttonName: "auth_password_submit",
        section_name: "Password submit page",
        screen_name: "Password submit page",
        event_type: "button_click",
        page_url: import.meta.env.VITE_PUBLIC_URL,
        error_message: "",
      },
      OTP: {
        event: "gaGenericEvent",
        event_name: "cta_auth_otp",
        buttonName: "auth_otp",
        section_name: "Authentication Methods",
        screen_name: "Authentication Methods",
        event_type: "button_click",
        page_url: import.meta.env.VITE_PUBLIC_URL,
        error_message: "",
      },
      OTP_SUBMIT_PAGE: {
        event: "gaGenericEvent",
        event_name: "cta_auth_otp_submit",
        buttonName: "auth_otp_submit",
        section_name: "Otp Submit page",
        screen_name: "Otp Submit page",
        event_type: "button_click",
        page_url: import.meta.env.VITE_PUBLIC_URL,
        error_message: "",
      },
      SOCIAL_APPLE: {
        event: "gaGenericEvent",
        event_name: "cta_socialauth",
        buttonName: "social_auth_apple",
        section_name: "Apple social authentication button",
        screen_name: "Authentication screen",
        event_type: "button_click",
        page_url: import.meta.env.VITE_PUBLIC_URL,
        error_message: "",
      },
      SOCIAL_GOOGLE: {
        event: "gaGenericEvent",
        event_name: "cta_socialauth",
        buttonName: "social_auth_google",
        section_name: "Google social authentication button",
        screen_name: "Authentication screen",
        event_type: "button_click",
        page_url: import.meta.env.VITE_PUBLIC_URL,
        error_message: "",
      },
    },
    REG_CONSENT: {
      event: "gaGenericEvent",
      event_name: "cta_register_consent",
      buttonName: "register_consent_submit",
      section_name: "consent register form submit",
      screen_name: "consent register form submit",
      event_type: "button_click",
      page_url: import.meta.env.VITE_PUBLIC_URL,
      error_message: "",
    },
  },
  AUTH_LANDING: {
    LOGIN: {
      BUTTON: {
        event: "gaGenericEvent",
        event_name: "cta_login_intro",
        buttonName: "login",
        section_name: "login intro",
        event_type: "button_click",
        screen_name: "login intro",
        user_status: "",
        timestamp: Date.now(),
      },
      LINK: {
        event: "gaGenericEvent",
        event_name: "cta_login_intro",
        buttonName: "don't have an account? sign up",
        section_name: "login intro",
        event_type: "link_click",
        screen_name: "login intro",
        user_status: "",
        timestamp: Date.now(),
      },
    },
    SIGNUP: {
      BUTTON: {
        event: "gaGenericEvent",
        event_name: "cta_signup_intro",
        buttonName: "signup",
        section_name: "signup intro",
        event_type: "button_click",
        screen_name: "signup intro",
        user_status: "",
        timestamp: Date.now(),
      },
      LINK: {
        event: "gaGenericEvent",
        event_name: "cta_signup_intro",
        buttonName: "already have an account? login",
        section_name: "signup intro",
        event_type: "link_click",
        screen_name: "signup intro",
        user_status: "",
        timestamp: Date.now(),
      },
    },
  },
  SYMPTOM_TRACKER: {
    SAVE_CONTINUE: {
      event: "gaGenericEvent",
      event_name: "cta_symptom_save_continue",
      buttonName: "save_and_continue",
      screen_name: "symptom_tracker",
      section_name: "Symptom Tracker",
      event_type: "button_click",
      error_message: "",
      user_status: "",
      category_name: "",
      timestamp: Date.now(),
    },
    SAVE_EXIT: {
      event: "gaGenericEvent",
      event_name: "cta_symptom_save_exit",
      buttonName: "save_and_exit",
      screen_name: "symptom_tracker",
      section_name: "Symptom Tracker",
      event_type: "button_click",
      error_message: "",
      user_status: "",
      category_name: "",
      timestamp: Date.now(),
    },
    SUBMIT: {
      event: "gaGenericEvent",
      event_name: "cta_symptom_submit",
      buttonName: "submit",
      screen_name: "symptom_tracker",
      section_name: "Symptom Tracker",
      event_type: "button_click",
      error_message: "",
      user_status: "",
      category_name: "",
      timestamp: Date.now(),
    },
  },
  VOUCHER_POPUP: {
    SIGNUP: {
      event: "gaGenericEvent",
      event_name: "cta_signup_and_claim",
      buttonName: "signup_and_claim",
      section_name: "signup_and_claim",
      event_type: "button_click",
      screen_name: "voucher_popup",
      user_status: "",
      timestamp: Date.now(),
    },
    MAY_BE_LATER: {
      event: "gaGenericEvent",
      event_name: "cta_may_be_later",
      buttonName: "may_be_later",
      section_name: "may_be_later",
      event_type: "button_click",
      screen_name: "voucher_popup",
      user_status: "",
      timestamp: Date.now(),
    },
    COPY_CODE: {
      event: "gaGenericEvent",
      event_name: "cta_copy_code",
      buttonName: "copy_code",
      section_name: "copy_code",
      event_type: "button_click",
      screen_name: "voucher_popup",
      user_status: "",
      timestamp: Date.now(),
    },
  },
};
